import React, { Fragment, useMemo, useCallback } from 'react'

import PlacesAutocomplete from 'react-places-autocomplete'

import { ProgressBar, Option, StepError } from '../'
import { setMatchMakerQuestion } from '../../../../services/match-maker'

const AutocompleteItem = ({ formattedSuggestion }) => (
  <div
    style={{
      zIndex: 999
    }}
  >
    <strong>{formattedSuggestion.mainText}</strong>{' '}
    <small>{formattedSuggestion.secondaryText}</small>
  </div>
)

const SecondStep = ({ state, dispatch, goToNextStep, goToPreviousStep, maxSteps }) => {
  const handleAddressChange = useCallback(
    address => dispatch({ type: 'set_address', payload: address }),
    [state]
  )

  const inputProps = useMemo(
    () => ({
      value: state.form_values.address,
      onChange: handleAddressChange,
      placeholder: 'CEP, bairro ou cidade',
      type: 'search',
      className: 'match-maker-text-input'
    }),
    [state]
  )

  const submitSecondStep = useCallback(async () => {
    dispatch({ type: 'set_status', payload: 'loading' })
    try {
      const { data } = await setMatchMakerQuestion({
        id_session: state.id_session,
        answers: [
          {
            question: state.questions[1].id,
            answer: state.form_values.address
          }
        ]
      })
      goToNextStep(data)
    } catch {
      dispatch({ type: 'set_status', payload: 'error' })
    }
  }, [state.form_values.address, state.form_values.location_preference])

  if (state.status === 'error') {
    return <StepError stepImage='/static/images/match-maker/02.png' submitStep={submitSecondStep} />
  }

  return (
    <Fragment>
      <div className='step__illustration lg:hidden'>
        <img src='/static/images/match-maker/02.png' width='100%' />
      </div>
      <div className='step__question'>
        <p className='step__question__title'>Como você prefere ser atendido?</p>
        <p className='step__question__description'>
          O atendimento online é feito por videoconferência em uma plataforma segura
        </p>
        <div className='flex flex-col second-question'>
          <div className='step__question__template type-service'>
            <Option
              selected={state.form_values.location_preference === 'online'}
              onClick={() => dispatch({ type: 'set_location_preference', payload: 'online' })}
            >
              Online
            </Option>
            <Option
              selected={state.form_values.location_preference === 'presencial'}
              onClick={() => dispatch({ type: 'set_location_preference', payload: 'presencial' })}
            >
              Presencial
            </Option>
          </div>
          {state.form_values.location_preference === 'presencial' &&
            process.browser &&
            window &&
            window.google &&
            window.google.maps && (
              <PlacesAutocomplete
                className='teste'
                inputProps={inputProps}
                autocompleteItem={AutocompleteItem}
                googleLogo={false}
                options={{
                  componentRestrictions: { country: 'br' }
                }}
                ref={c => {
                  if (!c) return
                  c.handleInputOnBlur = () => {}
                }}
              />
            )}
        </div>
        <div className='step__question__info'>
          <div className='step__question__info__next-step-container'>
            <div className='step__question__info__next-step-container__navigation'>
              <button
                className='button-verm-leaked match-maker-button mr-3'
                onClick={goToPreviousStep}
              >
                Voltar
              </button>
              <button
                disabled={
                  state.form_values.location_preference === 'presencial'
                    ? !state.form_values.address.length > 0
                    : state.form_values.location_preference !== 'online'
                }
                className='button-verm match-maker-button'
                onClick={submitSecondStep}
                id='step2-matchmaking'
              >
                Próximo
              </button>
            </div>
            {state.current_step > 0 && (
              <ProgressBar maxSteps={maxSteps} visualStep={state.visual_step} />
            )}
          </div>
        </div>
      </div>
    </Fragment>
  )
}

export { SecondStep }
